import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/service/jobs')({
  staticData: { crumb: 'serviceJobs' },
  component: Outlet,
})
